<div class="person-form">
  <div *ngIf="loading" class="padding text-center">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <div *ngIf="person">
    <div *ngIf="hasErrors()" class="alert alert-danger error-bar m-x-sm">
        <span class="text-danger  d-flex align-items-center">
          <i class="fa fa-exclamation-circle fa-2x"></i>
        </span>

      <div class="error-text text-dark" id="error-panel-desc">
        <strong>{{ 'SDC.error.title' | translate }}</strong>
        <div>
          {{ 'SDC.error.description' | translate }}
          <ng-container *ngFor="let entity of failedEntities(); let isLast = last">
            <a class="text-danger" (click)="scrollTo(entity)">{{ entity }}</a>{{ isLast ? '.' : ', ' }}
          </ng-container>
        </div>
      </div>

      <button class="btn btn-danger d-flex align-items-center gap-2" (click)="openErrorPanel()">
        <i class="fa fa-exclamation-triangle m-x-sm"> </i>
        <span>{{ 'SDC.error.view' | translate }}</span>
      </button>
    </div>

    <gp-side-panel
      [isSidePanelOpen]="errorPanelOpened"
      (isSidePanelOpenChange)="onChange($event)"
      [sidePanelTitle]="'SDC.error.details' | translate">
      <div class="box-body m-t-sm">
        <ng-container *ngIf="failedSdcLogs() as failedLogs">
          <gp-sdc-person-feedback
            *ngFor="let sdcLog of failedLogs"
            [sdcLog]="sdcLog">
          </gp-sdc-person-feedback>
        </ng-container>
      </div>
    </gp-side-panel>

    <div class="expand-section m-b m-r-sm">
      <button
        class="btn btn-xs btn-outline-primary sdc-expand"
        type="button"
        (click)="toggleExpandAll()">
        <em class="fa-solid" [class.fa-angles-up]="expandAll" [class.fa-angles-down]="!expandAll"></em>
        <span class="m-l-xs">{{ (expandAll ? 'SDC.collapse.all' : 'SDC.expand.all') | translate }}</span>
      </button>
    </div>

    <ng-container *ngFor="let personEntity of personEntities">
      <gp-sdc-person-data-card
        [metadata]="metadata(personEntity)"
        [data]="data(personEntity)"
        [attr.id]="personEntity + '-entityBlock'"
        [expandAll]="expandAll">
      </gp-sdc-person-data-card>
    </ng-container>

    <!-- family member and history -->
    <gp-card>
      <h3 card-title>FamilyMember</h3>
      <ng-container card-body *ngIf="data('FamilyMember') as familyMembers">
        <ng-container
          *ngIf="(familyMembers.length > 0 ? familyMembers : null) as familyMembers; else noFamilyMembers">
          <ng-container *ngFor="let familyMember of familyMembers; last as isLast">
            <gp-sdc-person-data-items
              [standardFields]="familyMemberStandardFields()"
              [additionalFields]="familyMemberAdditionalFields()"
              [dated]="familyMemberIsDated()"
              [data]="[familyMember]"
              id="FamilyMember-entityBlock"
              [expandAll]="expandAll">
            </gp-sdc-person-data-items>
            <gp-sdc-person-data-card
              [metadata]="metadata('FamilyMemberHistory')"
              [data]="familyMemberHistoryData(familyMember)"
              id="FamilyMemberHistory-entityBlock"
              [expandAll]="expandAll">
            </gp-sdc-person-data-card>
            <hr *ngIf="!isLast">
          </ng-container>
        </ng-container>
        <ng-template #noFamilyMembers>
          <gp-sdc-person-data-items
            [standardFields]="familyMemberStandardFields()"
            [additionalFields]="familyMemberAdditionalFields()"
            [dated]="familyMemberIsDated()"
            [data]="[]"
            [expandAll]="expandAll">
          </gp-sdc-person-data-items>
          <gp-sdc-person-data-card
            [metadata]="metadata('FamilyMemberHistory')"
            [data]="[]"
            [expandAll]="expandAll">
          </gp-sdc-person-data-card>
        </ng-template>
      </ng-container>
    </gp-card>

    <!-- employment and children -->
    <gp-sdc-person-data-card
      [metadata]="metadata('Employment')"
      [data]="data('Employment')"
      id='Employment-entityBlock'>
      <ng-container *ngFor="let employmentEntity of employmentEntities">
        <gp-sdc-person-data-card
          [metadata]="metadata(employmentEntity)"
          [data]="data(employmentEntity)"
          [attr.id]="employmentEntity + '-entityBlock'"
          [expandAll]="expandAll">
        </gp-sdc-person-data-card>
      </ng-container>
    </gp-sdc-person-data-card>

  </div>
</div>
